import {
  useAuthenticatedContext,
  useGetHolisticAuthorizationEvaluators,
} from "#src/contexts/AuthenticatedContext.helpers";
import { FeatureFlags, PermissionsMap } from "@validereinc/domain-controllers";

/**
 * Whether the signed-in user may approve or reject investigation write (HITL) proposals.
 * Mirrors agent invoke gating: company `stratos:write_actions` flag and an explicit
 * `stratos:write_actions` role grant (company admin `*` does not substitute).
 *
 * @returns `[canSubmit, isLoading]` — allow/deny for write approval actions, then whether
 * auth (permissions and feature flags) is still loading.
 */
export const useCanSubmitInvestigationWriteApproval = (): [
  boolean,
  boolean,
] => {
  const {
    v2: { isLoading },
  } = useAuthenticatedContext();
  const { isFeatureEnabledWaterfall, hasExplicitPermissions } =
    useGetHolisticAuthorizationEvaluators();

  const canSubmit =
    isFeatureEnabledWaterfall({
      featureFlagQuery: FeatureFlags.StratosWriteActions,
    }) &&
    hasExplicitPermissions({
      permissionsQuery: PermissionsMap.StratosWriteActions,
    });

  return [canSubmit, isLoading];
};
